﻿import clsx from 'clsx';
import React, { LegacyRef, PropsWithChildren } from 'react';
import { BaseProps } from './BaseProps';

export const Button = React.forwardRef(
  (
    {
      className,
      active,
      ...props
    }: PropsWithChildren<
      {
        active: boolean;
        reversed: boolean;
      } & BaseProps
    >,
    ref: LegacyRef<HTMLSpanElement> | undefined
  ) => (
    <span
      className={clsx('form-control-rich-text__toolbar__button', className, {
        active: active,
      })}
      {...props}
      ref={ref}
    />
  )
);
